import React from 'react'
import footerimg from '../Assets/image 2.png'
import { Link } from 'react-router-dom'
function Footer() {
  return (
    <>
        <div className='Footer'>
        <div className='Footer-top'>

      <div className='Footer-div'>
      <img src={footerimg}/>
    <h3>Innovative Engineering
solutions for everyone.</h3>
<button>Contact us</button>
        </div>
        <ul>
        Our Offerings
        <Link className='none2' to='/siliconengineering'>

        <li>Silicon Engineering</li>
        </Link>
        <Link className='none2' to='/systemdesign'>


        <li>System Design Engineering</li>
        </Link>
        <Link className='none2' to='/automotivesolutions'>


        <li>Automotive Solutions</li>
        </Link>
        <Link className='none2' to='/artificialintelligence'>


        <li>Artificial Intelligence</li>
        </Link>



        </ul>
          <ul>
       Company
        <Link className='none2' to='/about'>


        <li>About Us</li>
        </Link>
        <Link className='none2' to='/career'>

        <li>Career</li>
        </Link>

        <Link className='none2' to='/contact'>


        <li>Contact Us</li>
        </Link>
        
        <Link className='none2' to='/terms'>

        <li>Terms and Conditions</li>
        </Link>


        <Link className='none2' to='/privacypolicy'>


        <li>Privacy Policy</li>

        </Link>


        </ul>
          <ul>
        Official Info
        <li>+91 99029-78741</li>
        <li>hr@semicave.com</li>
        <li>Ground floor, PFS Club House,<br/> Marathahalli Main Rd, R.J.Gardens,<br/> Lakshminarayana Pura, EPIP Zone, <br/> Chinnapanna  Halli, Bengaluru,<br/> Karnataka 560037</li>
       



        </ul>
        </div>
        <div className='footer-bottom'>
        <h3>© Semicave Semiconductor Private Limited All Rights Reserved. Designed & Developed by <Link to='https://www.strixdigital.in/' style={{color:'white' , textDecoration:'none'}}>Strix Digital</Link></h3>

        </div>
        </div>

    </>
  )
}

export default Footer